import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimDocument.Edit.IRequest;
type Response = Api.Core.ClaimDocument.Edit.IResponse;
type Headers = Api.Core.ClaimDocument.Edit.IHeaders;
const url = '/api/Claims/Claim/:id/Documents';
export default async function claimDocumentEditApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id: body?.claimId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
